<div class="modal-body relative p-4">
  <ng-content></ng-content>
</div>
